import { render, staticRenderFns } from "./OverconsumptionChartPanel.vue?vue&type=template&id=52ccaff0&scoped=true&"
import script from "./OverconsumptionChartPanel.vue?vue&type=script&lang=js&"
export * from "./OverconsumptionChartPanel.vue?vue&type=script&lang=js&"
import style0 from "./OverconsumptionChartPanel.vue?vue&type=style&index=0&id=52ccaff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ccaff0",
  null
  
)

export default component.exports